import React from 'react';
import useLanguage from '../../../../hooks/useLanguage';
import PropTypes from 'prop-types';

const ServicesFaq = ({ faqData }) => {
  const langToggle = useLanguage;
  const [active, setActive] = React.useState(0);

  return (
    <section className="services-faq" data-scroll-section>
      <div className="content-wrapper">
        <header className="services-approach__header">
          <div className="services-approach__marker-wrapper">
            <span className="services-approach__marker">FAQ</span>
          </div>
          <div className="services-approach__title-wrapper">
            <h2 className="services-approach__title">
              {langToggle(faqData.title_ua, faqData.title_ru)}
            </h2>
          </div>
        </header>
        <ul className="services-faq__accordion">
          {faqData.Items.map((item, index) => {
            const counter = ++index;
            return (
              <li className="services-faq__accordion-item" key={index}>
                <button
                  className="accordion-item__header"
                  onClick={() =>
                    active === item.id ? setActive(0) : setActive(item.id)
                  }
                >
                  <span className="accordion-item__header-wrapper">
                    <span className="accordion-item__header-count">
                      {counter <= 9 ? '0' + counter + '.' : counter + '.'}
                    </span>
                    <div className="accordion-item__header-title__wrapper">
                      <h3 className="accordion-item__header-title">
                        {langToggle(item.question_ua, item.question_ru)}
                      </h3>
                    </div>

                    <span className="accordion-item__header-icon__wrapper">
                      <span
                        className={
                          active === item.id
                            ? 'accordion-item__header-icon is-active'
                            : 'accordion-item__header-icon'
                        }
                      >
                        <span className="header-icon__line header-icon__line-1"></span>
                        <span className="header-icon__line header-icon__line-2"></span>
                      </span>
                    </span>
                  </span>
                </button>
                <div
                  className={
                    active === item.id
                      ? 'accordion-item__content-wrapper is-active'
                      : 'accordion-item__content-wrapper'
                  }
                >
                  <div className="accordion-item__content">
                    <p className="accordion-item__content-text">
                      {langToggle(item.answer_ua, item.answer_ru)}
                    </p>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

ServicesFaq.propTypes = {
  faqData: PropTypes.object,
};

export default ServicesFaq;
